import { memo, useState } from "react";
import TextEditor from "../TextEditor";
import { useGetTextHomepage } from "../../../hooks/query/useGetTextHomepage";
import { useCreateTextHomepage } from "../../../hooks/query/useCreateTextHomepage";
import { useUpdateTextHomepage } from "../../../hooks/query/useUpdateTextHomepage";
import CarouselEditor from "../CarouselEditor";

function Setting() {
  const [saveStatus, setSaveStatus] = useState<"idle" | "success" | "error">("idle");

  const { data: homepage, isLoading } = useGetTextHomepage();
  const createHomepage = useCreateTextHomepage();
  const updateHomepage = useUpdateTextHomepage();

  const handleSave = async (html: string) => {
    const options = {
      onSuccess: () => {
        setSaveStatus("success");
        setTimeout(() => setSaveStatus("idle"), 2500);
      },
      onError: () => {
        setSaveStatus("error");
        setTimeout(() => setSaveStatus("idle"), 2500);
      },
    };

    if (homepage?.id) {
      updateHomepage.mutate({ description: html, id: String(homepage.id) }, options);
    } else {
      createHomepage.mutate(html, options);
    }
  };

  const handleCancel = () => {
    setSaveStatus("idle");
  };

  const isSaving = createHomepage.isPending || updateHomepage.isPending;

  return (
    <div className="w-full min-h-screen p-[20px] text-white">
      <h1 className="font-bold text-[30px] text-center">CÀI ĐẶT</h1>
      <h2 className="text-lg font-semibold text-gray-200">Cài đặt Trang chủ</h2>
      <section className="mt-[20px]">
        <div className="flex items-center justify-between mb-3">
          {saveStatus === "success" && (
            <span className="flex items-center gap-1.5 text-green-400 text-sm">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
              Đã lưu thành công
            </span>
          )}
          {saveStatus === "error" && (
            <span className="flex items-center gap-1.5 text-red-400 text-sm">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
              </svg>
              Lưu thất bại, thử lại
            </span>
          )}
        </div>
        <h3 className="text-sm text-gray-400 mb-2">Nội dung văn bản trang chủ</h3>
        <TextEditor
          placeholder="Nhập nội dung trang chủ..."
          minHeight="240px"
          initialValue={homepage?.description ?? ""}
          isLoading={isLoading}
          isSaving={isSaving}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </section>
      <section className="mt-[20px]">
        <h3 className="text-sm text-gray-400 mb-2">Nội dung carousel</h3>
        <CarouselEditor/>
      </section>
    </div>
  );
}

export default memo(Setting);